import { render, staticRenderFns } from "./DappDetailedLogo.vue?vue&type=template&id=3ad6fbe4&scoped=true"
import script from "./DappDetailedLogo.vue?vue&type=script&lang=ts"
export * from "./DappDetailedLogo.vue?vue&type=script&lang=ts"
import style0 from "./DappDetailedLogo.vue?vue&type=style&index=0&id=3ad6fbe4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad6fbe4",
  null
  
)

export default component.exports